import { render, staticRenderFns } from "./ESay.vue?vue&type=template&id=5120dabb&scoped=true&"
import script from "./ESay.vue?vue&type=script&lang=js&"
export * from "./ESay.vue?vue&type=script&lang=js&"
import style0 from "./ESay.vue?vue&type=style&index=0&id=5120dabb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5120dabb",
  null
  
)

export default component.exports